import { User } from '../types/user';
import axiosInstance from '../api/apiInterceptor';
import { AxiosResponse } from 'axios';
import { User_API_ENDPOINT , ALL_USERS_API_ENDPOINT} from "../../../constants/constants"

interface LoginPayload {
  userId: number;
}

export const fetchUsersApi = async (payload: LoginPayload): Promise<User[]> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get(
      `${User_API_ENDPOINT}${payload.userId}`
    );
    return response.data.data;
  } catch (error: any) {
    console.error('Error fetching Users:', error);
    throw new Error(error.message);
  }
}

export const fetchCurrentUserApi = async (): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get(
      `${User_API_ENDPOINT}` 
    );
    return response.data.data;
  } catch (error: any) {
    console.error('Error fetching current user:', error);
    throw new Error(error.message);
  }
}

// Add this function to get user details
export const fetchCurrentUserDetailApi = async (): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get(
      `${User_API_ENDPOINT}` 
    );
    return response.data.data;
  } catch (error: any) {
    console.error('Error fetching user details:', error);
    throw new Error(error.message);
  }
}

export const addUserApi = async (UserData: Omit<User, 'id'>): Promise<User> => {
  try {
    const response: AxiosResponse<User> = await axiosInstance.post(User_API_ENDPOINT, UserData);
    return response.data;
  } catch (error: any) {
    console.error('Error adding User:', error);
    throw new Error(error.message);
  }
};

// Add this function to get user details
export const fetchAllUsersApi = async (): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get(
      `${ALL_USERS_API_ENDPOINT}` 
    );
    return response.data.data;
  } catch (error: any) {
    console.error('Error fetching user details:', error);
    throw new Error(error.message);
  }
}

// New: server-side search + pagination for users
export interface SearchUsersParams {
  search?: string;
  page?: number;
  limit?: number;
  role?: string | number;
}

export interface PagedUsersResponse<T = any> {
  data: T[];
  page: number;
  limit: number;
  total: number;
}

export const searchUsersApi = async (
  params: SearchUsersParams
): Promise<PagedUsersResponse> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get(ALL_USERS_API_ENDPOINT, {
      params: {
        search: params.search || '',
        page: params.page || 1,
        limit: params.limit || 10,
        role: params.role,
      },
    });

    // Try to normalize common API shapes
    const payload = response.data;
    if (payload?.data && Array.isArray(payload.data)) {
      return {
        data: payload.data,
        page: payload.page ?? params.page ?? 1,
        limit: payload.limit ?? params.limit ?? 10,
        total: payload.total ?? payload.count ?? payload.data.length,
      };
    }

    if (Array.isArray(payload)) {
      return {
        data: payload,
        page: params.page || 1,
        limit: params.limit || payload.length,
        total: payload.length,
      };
    }

    return {
      data: payload?.results || [],
      page: payload?.page ?? params.page ?? 1,
      limit: payload?.limit ?? params.limit ?? 10,
      total: payload?.total ?? payload?.count ?? (payload?.results?.length || 0),
    };
  } catch (error: any) {
    console.error('Error searching users:', error);
    throw new Error(error.message);
  }
};